__turbopack_context__.v({
  "body": "aq-HCq_body",
  "footer": "aq-HCq_footer",
  "footerBody": "aq-HCq_footerBody",
  "footerLayout": "aq-HCq_footerLayout",
  "transparent": "aq-HCq_transparent",
});
